<template>
    <Layout>
        <template #title><strong>{{ $t("manager.title") }}</strong></template>

        <template #nav> </template>

        <template #main>
            <!-- <div class="col-sm-5">
                    <b-form-group :label="$t('table.filter.label')" label-cols-sm="2" label-align-sm="right" label-size="sm"
                        label-for="filterInput" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input v-model="filter" :debounce="700" type="search" id="filterInput"
                                :placeholder="$t('table.filter.placeholder')"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
            </div>-->
            <div class="row justify-content-end pb-3">
                <div class="col-5 d-flex align-items-center">
                    <span>{{ $t('table.filter.label') }}</span>
                    <input v-model="filter" :placeholder="$t('table.filter.placeholder')" class="ms-3 form-control">
                    <button @click="filter = ''" :disabled="!filter" class="ms-1 btn btn-primary py-2">{{ $t("table.filter.cancel") }}</button>
                </div>
            </div>
            <Table
                :itemsDataProviderSettings="itemsProviderSettings"
                :columns="fields"
                :filter="filter"
                v-model:sortBy="sortBy"
                v-model:sortDesc="sortDesc"
            >
                <template v-slot:data_start_date="data">
                    {{ $filters.formatDate(data.item.start_date, "M/YYYY") }} -
                    {{ $filters.formatDate(data.item.end_date, "M/YYYY") }}
                </template>

                <template v-slot:data_hash="data">
                    <router-link :to="{
                        name: 'teaser',
                        params: { hash: data.item.teaser_hash },
                    }" class="btn btn-sm btn-outline-danger px-2 py-1 d-block my-2">
                        Teaser
                    </router-link>
                    <router-link v-if="data.item.version == 'lite'" :to="{
                        name: 'lite',
                        params: { hash: data.item.lite_hash },
                    }" class="btn btn-sm btn-danger px-2 py-1 d-block my-2">
                        Lite
                    </router-link>
                    <router-link v-if="data.item.version == 'full'" :to="{
                        name: 'full',
                        params: { hash: data.item.full_hash },
                    }" class="btn btn-sm btn-danger px-2 py-1 d-block my-2">
                        Full
                    </router-link>
                    <button class="btn btn-sm btn-outline-danger px-2 py-1 d-block" @click="generateHashes(data.item)"
                        :disabled="generateHashesBusy">
                        nové hashe
                    </button>
                </template>

                <template v-slot:data_created="data">
                    <div class="row small_text">
                        <div class="col">
                            modified:<br>
                            {{ data.item.modified }}
                        </div>
                    </div>
                    <div class="row small_text">
                        <div class="col">
                            created:<br>
                            {{ data.item.created }}
                        </div>
                    </div>
                    <div class="row small_text">
                        <div class="col">
                            origin_created:<br>
                            {{ data.item.origin_created }}
                        </div>
                    </div>
                </template>
            </Table>
        </template>
    </Layout>
</template>

<script>
import Layout from "@/views/layouts/Manager.vue";
import Loader from "@/components/Loader.vue";
import Table from "@/components/Table.vue";
import axios from "axios";
import { CONFIG } from "@/config.js";

export default {
    name: "analysis-manager",
    components: { Layout, Loader, Table },
    mounted: function () { },
    beforeRouteEnter(from, to, next) {
        axios
            .get(CONFIG.apiBaseUrl + "api/v1/user_profile", {
                withCredentials: true,
                xsrfCookieName: "csrftoken_new",
                xsrfHeaderName: "X-CSRFToken",
            })
            .then(() => next());
    },
    data: function () {
        return {
            isBusy: false,
            totalRows: 0,
            sortBy: "created",
            sortDesc: true,
            filter: "",
            generateHashesBusy: false,
            itemsProviderSettings: {
                url: "analysis/",
                credentials: true
            }
        };
    },
    computed: {
        settings: function () {
            return {
                filter: this.filter,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                emptyText: this.$t("table.empty"),
                emptyFilteredText: this.$t("table.filter.empty"),
                labelSortAsc: this.$t("table.sort.asc"),
                labelSortDesc: this.$t("table.sort.asc"),
                labelSortClear: this.$t("table.sort.asc"),
            };
        },
        fields: function () {
            return [
                {
                    key: "origin_id",
                    label: "origin id",
                },
                {
                    key: "id",
                    label: "id",
                },
                {
                    key: "ico",
                    sortable: true,
                    label: this.$t("organization_id"),
                },
                {
                    key: "name",
                    sortable: true,
                    label: this.$t("manager.table.head.name"),
                },
                {
                    key: "start_date",
                    sortable: true,
                    label: this.$t("period"),
                },
                {
                    key: "created",
                    sortable: true,
                    class: "text-nowrap",
                    label: this.$t("manager.table.head.created"),
                },
                {
                    key: "hash",
                    label: "",
                    sortable: false,
                },
            ];
        }
    },
    methods: {
        generateHashes: function (item) {
            if (confirm(`Opravdu chcete přegenerovat hashe pro analýzu\n"${item.name}"?\n\nZměna je nevratná!!!`)) {
                this.generateHashesBusy = true
                axios
                    .get(`${CONFIG.apiBaseUrl}api/v1/generate_analysis_hash/${item.id}`, {
                        withCredentials: true,
                        xsrfCookieName: "csrftoken_new",
                        xsrfHeaderName: "X-CSRFToken",
                    })
                    .then(response => Object.assign(item, response.data))
                    .finally(() => this.generateHashesBusy = false);
            }
        }
    },
};
</script>

<style scoped lang="scss">
#perPageSelect {
    width: 70px;
}

.small_text {
    font-size: 60%;
}
</style>
